import {
  Create,
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  Toolbar,
  EditButton,
  DateField,
  BooleanField,
  AutocompleteInput,
  NullableBooleanInput,
  ReferenceInput,
  TextInput,
  ImageField,
} from "react-admin";
import UploadImage from "../shared/uploadImage";

export const InputList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <ImageField source="image" />
        <EditButton></EditButton>
      </Datagrid>
    </List>
  );
};

export const InputCreate = (props) => {
  return (
    <Create title="Add supervisors " {...props} redirect="list">
      <SimpleForm>
        <TextInput source="name" />
        <UploadImage name="image" />
      </SimpleForm>
    </Create>
  );
};

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const InputEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<UserEditToolbar />}>
        <TextInput source="name" />
        <UploadImage name="image" />
      </SimpleForm>
    </Edit>
  );
};
